import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  card: ({ align, withShadow, clickable, __instanceId }: any) => ({
    compId: __instanceId,
    padding: 16,
    ...(withShadow && {
      transition: "box-shadow 0.3s ease, transform 0.2s ease",
    }),
    textAlign: align,
    position: "relative",
    ...(clickable && { cursor: "pointer" }),
  }),
});

type CardProps = {
  children: any;
  backgroundColor?: string;
  borderColor?: string;
  borderPosition?: "top" | "left" | "right" | "bottom" | "all";
  style?: any;
  align?: string;
  withShadow?: boolean;
  clickable?: boolean;
  onClick?: any;
  onHover?: any;
  onHoverOut?: any;
};

export const Card: React.FC<CardProps> = ({
  children,
  backgroundColor = "var(--card-background)",
  borderColor = "var(--green)",
  borderPosition = "left",
  align = "left",
  withShadow = true,
  clickable = false,
  onClick = () => {},
  onHover = () => {},
  onHoverOut = () => {},
  style,
}) => {
  const instanceId = React.useRef(Math.random().toString(36).slice(2)).current;

  const classes = useStyles({
    __instanceId: instanceId,
    align,
    withShadow,
    clickable,
  });

  return (
    <div
      className={`${classes.card} ${clickable ? "click_card card" : "card"}`}
      onClick={onClick}
      onMouseOver={onHover}
      onMouseOut={onHoverOut}
      style={{
        ...style,
        backgroundColor,
        borderRadius: "var(--box-radius)",
        ...(borderPosition === "top" && { borderTop: `2px solid ${borderColor}` }),
        ...(borderPosition === "left" && { borderLeft: `2px solid ${borderColor}` }),
        ...(borderPosition === "right" && { borderRight: `2px solid ${borderColor}` }),
        ...(borderPosition === "bottom" && { borderBottom: `2px solid ${borderColor}` }),
        ...(borderPosition === "all" && { border: `1px solid ${borderColor}` }),
      }}>
      {children}
    </div>
  );
};
